const ComponentsLookup = {
  "default-footer": "DefaultFooter02255735Fe27428aBa1088fae2193c8b",
  "default-header-top": "DefaultHeaderTopC6d47dcdDbcc44d5AafcEbdffdfe64b5",
  "secondary-marketing-header": "SecondaryMarketingHeader3a1dc6acB37e469b9f9dBd97afd16510",
  "about-us-page": "AboutUsPage2b5e4892Cda747e9A6882f74eca39265",
  "public-events-page": "PublicEventsPage0c86bd6f6f0c45f8B8ba822f0954652a",
  "join-us-page": "JoinUsPage5dce7bd7F69d4f2a90a2A49d4ea3900a",
  "application-pages": "ApplicationPages1359e263160a431480fe8be85f55c3fb",
  "secondary-page": "SecondaryPageB9948ab8A1c04aa4A5dc05bb15bd4641",
  "secondary-marketing-hero": "SecondaryMarketingHeroD61b2a831d644738A4c4719bc23ed679",
  "home-page": "HomePageA5a63df222454e98A2c778283457aa26"
}

export default ComponentsLookup;